'use client';

import type {FC} from 'react';
import {useId} from 'react';

import type {InputProps} from '../Input';
import {Input} from '../Input';
import type {LabelProps} from '../Label';
import {Label} from '../Label';

export type TextFieldProps = Omit<InputProps, 'id' | 'aria-describedby'> & {
	label: string;
	error?: string | null;
	labelProps?: Omit<LabelProps, 'htmlFor'>;
};

export const TextField: FC<TextFieldProps> = ({label, labelProps, error, ...rest}) => {
	const inputId = useId();
	const errorId = useId();

	return (
		<div>
			<Label htmlFor={inputId} {...labelProps}>
				{label}
			</Label>
			<Input id={inputId} aria-describedby={error?.length ? errorId : undefined} {...rest} />
			{error?.length ? (
				<span id={errorId} role="alert" className="text-sm text-red-700">
					{error}
				</span>
			) : null}
		</div>
	);
};
